import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RadioGroupComponent } from './radio-group';
import { RadioComponent } from '../radio/radio';

@NgModule({
  imports: [CommonModule],
  declarations: [RadioGroupComponent, RadioComponent],
  exports: [RadioGroupComponent, RadioComponent]
})
export class RadioGroupModule {}
